import axios from './axiosInstances/axiosInstance';

export const logOutUser = () => {
  return axios.get(`/users/signOut`);
};
